import { Checkbox } from "antd-v5";
import { CheckboxChangeEvent } from "antd-v5/lib/checkbox";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { GSCCConfigAPI } from "restAPI/ToolsIntegrationAPI";

type SCCCheckboxHandleType = {
  getValue: () => boolean;
};

function SCCSkipIngestedFindingInMutedStateCheckbox(
  _: unknown,
  ref: React.Ref<SCCCheckboxHandleType>,
) {
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    const { promise, cancel } = GSCCConfigAPI.getConfig();
    promise
      .then((res) => {
        setChecked(res?.config?.skipMutedFindings ?? false);
      })
      .catch(() => {});

    return cancel;
  }, []);

  useImperativeHandle(ref, () => ({
    getValue: () => checked,
  }));

  return (
    <Checkbox
      onChange={(e: CheckboxChangeEvent) => setChecked(e.target.checked)}
      checked={checked}
    >
      Skip Ingestion of Findings in Muted State
    </Checkbox>
  );
}

export default forwardRef(SCCSkipIngestedFindingInMutedStateCheckbox);
